<template>
  <div class="table-users">
    <div class="dt-list-status">
      <div class="btn-status" :class="scrunch ? 'active' : null" @click="scrunch = !scrunch">
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
      </div>
      <div class="btn-status" :class="!scrunch ? 'active' : null" @click="scrunch = !scrunch">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="dt-content">
      <div class="dt-header" id="dt-header">
        <div class="header-col"
             :style="{ width: columnWidth.firstName.size ? (columnWidth.firstName.size + 'px') : '12%' }"
             @click="setSortOption('firstName')" id="firstName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('firstName', $event)"></div>

              <div class="content no-select">
                First Name
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'startTime'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'startTime' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'startTime' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.lastName.size ? (columnWidth.lastName.size + 'px') : '12%' }"
             @click="setSortOption('lastName')" id="lastName">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('lastName', $event)"></div>

              <div class="content no-select">
                Last Name
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'lastName'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'duration' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'duration' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
            :style="{ width: columnWidth.email.size ? (columnWidth.email.size + 'px') : '22%' }"
            @click="setSortOption('email')" id="email">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('email', $event)"></div>

              <div class="content no-select">
                Email
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'endTime'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'endTime' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'endTime' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.phone.size ? (columnWidth.phone.size + 'px') : '12%' }"
             @click="setSortOption('phone')" id="phone">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('phone', $event)"></div>

              <div class="content no-select">
                Phone
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'timeZone'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
            :style="{ width: columnWidth.clientAccount.size ? (columnWidth.clientAccount.size + 'px') : '10%' }"
             @click="setSortOption('clientAccount')" id="clientAccount">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('clientAccount', $event)"></div>

              <div class="content no-select">
                client account
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'timeZone'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
            :style="{ width: columnWidth.role.size ? (columnWidth.role.size + 'px') : '10%' }"
             @click="setSortOption('role')" id="role">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('role', $event)"></div>

              <div class="content no-select">
                Role
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'timeZone'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
             :style="{ width: columnWidth.role.size ? (columnWidth.role.size + 'px') : '14%' }"
             @click="setSortOption('role')" id="status">
          <div class="header-container">
            <div class="crop">
              <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('role', $event)"></div>

              <div class="content no-select">
                Status
                <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'status'"></Icon>
                <Icon name="sort-up" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
                <Icon name="sort-down" class="sort-icon"
                      v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
              </div>

            </div>
          </div>
        </div>
        <div class="header-col"
            :style="{ width: columnWidth.action.size ? (columnWidth.action.size + 'px') : '8%' }"
             id="action">
          <div class="header-container">
            <div class="crop">
              <div class="content no-select">
                action
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="dt-body" class="dt-body" :class="scrunch ? 'scrunch' : null">
        <div :class="{'isLoading': loading, 'noDisplay': !loading}" class="overlay">
          <div class="spinnerWrapper">
            <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
          </div>
        </div>
        <template v-for="(user, index) in users" v-if="!loading">
          <UserRow :userInfo="user" :index="index" :key="index"></UserRow>
        </template>
      </div>
    </div>
    <div class="dt-footer">
      <!-- <DtPaging v-if="!showOnModal && !showRelatedEvent" v-on:CHANGE_PAGING_OPTIONS="changePagingOptions" :currentPage="pagingObj.currentPage"
                :itemsPerPage="pagingObj.itemsPerPage" :totalItems="totalItems"></DtPaging> -->
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/sort';
import 'vue-awesome/icons/sort-up';
import 'vue-awesome/icons/sort-down';

import Icon from 'vue-awesome/components/Icon';
import {mapGetters, mapActions, mapMutations} from 'vuex';

// import Vue from 'vue';
import UserRow from './UserRow';
// import DtPaging from './DtPaging';
import consts from '../../_consts';
// const _ = require('lodash');
export default {
  name: 'table-users',
  components: {
    Icon,
    UserRow
  },
  data () {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '25',
        totalItems: this.totalItems,
        sortType: 'isChangeOrder',
        sortReverse: false
      },
      // END: paging
      arrCol: [
        {
          colName: 'firstName',
          newWidth: 175
        },
        {
          colName: 'lastName',
          newWidth: 175
        },
        {
          colName: 'email',
          newWidth: 350
        },
        {
          colName: 'clientAccount',
          newWidth: 175
        },
        {
          colName: 'phone',
          newWidth: 175
        },
        {
          colName: 'role',
          newWidth: 175
        },
        {
          colName: 'status',
          newWidth: 175
        },
        {
          colName: 'action',
          newWidth: 140
        }
      ]
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    users () {
      if (this.userList) {
        return this.userList(localStorage.getItem(consts.LOCAL_STORE.role));
      }
    },
    ...mapGetters({
      userList: 'GETTER_GET_USER_LIST',
      userListForEM: 'GETTER_GET_USER_LIST_FOR_EM',
      columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
    })
  },
  methods: {
    changePagingOptions: function (pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function (sortType) {
      if (!this.resizing) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      }
    },
    changeColumnWidth: function (colName, mouseDownEvent) {
      this.resizing = true;
      let vueApp = this;
      // get current mouse position
      let shiftX = mouseDownEvent.clientX;
      // header width
      let dtHeaderEl = document.getElementById('dt-header');
      let headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      let maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      let newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove (event) {
        // new position
        let bufferPx = event.clientX - shiftX;
        let newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && (maxLeft - Math.abs(bufferPx)) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2),
          isTableUser: true
        }, true);
      }

      function onMouseUp () {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(() => {
          vueApp.resizing = false;
        }, 50);
      }
    },
    ...mapActions({
      saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH'
    }),
    ...mapMutations({
      resetColumnWidth: 'MUTATION_RESET_COLUMN_SIZE'
    })
  },
  beforeMount () {
    this.arrCol.forEach((element) => {
      this.resetColumnWidth(element.colName);
    })
  },
  mounted () {
    let dtHeaderEl = document.getElementById('dt-header');
    let headerWidth = dtHeaderEl.getBoundingClientRect().width;
    if (headerWidth < 1200) {
      let newHeaderWidth = 1200;
      this.arrCol.forEach((element) => {
        this.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: element.colName,
          newWidth: element.newWidth,
          isTableUser: true
        })
      })
    }
  },
  watch: {
    pagingObj: {
      handler: function () {
        this.getEventList(this.getListEventParams());
        localStorage.setItem(consts.LOCAL_STORE.pagingOptions, JSON.stringify(this.getListEventParams()));
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
@import '~@/styles/variables.less';

.table-users {
  font-size: 14px;
  margin: 15px 20px 15px 15px;
  .dt-list-status {
    height: 37px;
    background-color: @grey-5;
    .btn-status {
      height: 37px;
      width: 37px;
      float: left;
      vertical-align: middle;
      display: grid;
      padding: 8px 0;
      &:hover {
        cursor: pointer;
        background-color: @white;
      }
      &.active {
        background-color: @white;
        .line {
          background-color: @black;
        }
      }
      .line {
        width: 18px;
        background: @grey-3;
        height: 3px;
        margin: 0 auto;
      }
      .scrunch {
        height: 2px;
      }
    }
  }

  .dt-content {
    overflow-x: scroll;
    overflow-y: hidden;
    .dt-header {
      font-size: 12px;
      height: 37px;
      background-color: @black;
      color: @white;
      line-height: 37px;
      /*overflow: hidden;*/
      .header-col {
        float: left;
        height: 37px;
        overflow: hidden;
        border-left: solid 1px @grey-3;
        padding-left: 10px;
        text-transform: uppercase;
        word-break: break-all;
        &:hover {
          cursor: pointer;
        }
        &:last-child {
          border-right: solid 1px @grey-3;
        }
        .sort-icon {
          vertical-align: middle;
          width: 6px;
          height: 10px;
          margin: 5px;
        }
      }
      .col-event-name {
        padding-left: 30px;
      }
    }
    .dt-body {
      clear: both;
      background-color: @grey-5;
      &.scrunch {
        .dt-row-user {
          height: 40px;
          .body-col {
            height: 40px;
          }
        }
      }
      .dt-row {
        /*max-width: 100%;*/
      }
      .dt-row-user{
        height: 50px;
        // margin: 2px auto;
      }
      .dt-row-detail {
        .body-col {
          float: left;
          height: 50px;
          line-height: 50px;
          padding: 0 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          &.overflow-show {
            overflow: visible;
          }
        }
      }
    }

    .header-col {
      .header-container {
        position: relative;
      }
      .crop {
        height: 37px;
        transition: all 0.25s;
        cursor: pointer;
      }

      .crop .crop-line {
        position: absolute;
        transition: all 0.25s;
      }
      .crop:hover .crop-line {
        border-color: @grey-3;
      }
      .crop .crop-top-line {
        top: 0;
        left: 0;
        right: 0;
        height: 5px; /* 5px for the mouse cursor update size */
        border-top: 1px solid @grey-3;
        cursor: n-resize;
      }
      .crop .crop-bottom-line {
        bottom: 0;
        left: 0;
        right: 0;
        height: 5px; /* 5px for the mouse cursor update size */
        border-bottom: 1px solid @grey-3;
        cursor: s-resize;
      }
      .crop .crop-left-line {
        top: 0;
        left: 0;
        bottom: 0;
        width: 5px; /* 5px for the mouse cursor update size */
        border-left: 1px solid @grey-3;
        cursor: col-resize;
      }
      .crop .crop-right-line {
        top: 0;
        right: 0;
        bottom: 0;
        width: 5px; /* 5px for the mouse cursor update size */
        border-right: 1px solid @grey-3;
        cursor: col-resize;
      }
      .crop .crop-corner {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 2px;
        border: 1px solid #808080;
        background: #FFF;
        opacity: 0;
        transition: all 0.25s;
      }
      .crop .crop-top-left-corner {
        top: -3px;
        left: -3px;
        cursor: nw-resize;
      }
      .crop .crop-top-right-corner {
        top: -3px;
        right: -3px;
        cursor: ne-resize;
      }
      .crop .crop-bottom-left-corner {
        bottom: -3px;
        left: -3px;
        cursor: sw-resize;
      }
      .crop .crop-bottom-right-corner {
        bottom: -3px;
        right: -3px;
        cursor: se-resize;
      }
      .crop:hover .crop-corner {
        opacity: 1;
      }
    }
    .small-text {
      font-size: 10px;
      .small-text-margin {
        .first-line {
          position: absolute;
          top: -5px;
        }
        .second-line {
          position: absolute;
          top: 8px;
        }
        .icon-section{
          position:  absolute;
          top: 1px;
          left: 50px;
        }
        // .icon-section-for-small-text{
        //   margin-left: 30px;
        // }
        // .sort-icon-small-text {
        // }
      }
    }
  }
}
.isLoading {
  display: block;
  text-align: center;
  color: #606060;
}
.noDisplay {
  display: none;
}
.spinnerWrapper{
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
}
.overlay {
  position: absolute;
  width: 97.5%;
  height: 62.5%;
  background-color: rgba(0,0,0,0.5);
  z-index: 99;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// TableUsers.vue?1a397b02